import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "..";
import type { CsiOverviewResponse } from "./CustomerSalesIncentive.types";

type CsiRequestParams = {
  abo: string;
  aff: string;
  locale: string;
  period: string;
};

export const csiAPI = createApi({
  reducerPath: "csiAPI",
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getCsiOverview: builder.query<CsiOverviewResponse, CsiRequestParams>({
      query: (params) => {
        const { abo, aff, locale, period } = params;
        const queryParams = new URLSearchParams({
          Abo: abo,
          Aff: aff,
          Locale: locale,
          Period: period,
        });

        return `/incentives-v2/api/csi/overview?${queryParams}`;
      },
    }),
  }),
});

export const { useGetCsiOverviewQuery } = csiAPI;
